import React from "react";
import { useRive } from "@rive-app/react-canvas";
import SlidingButton from "../components/ui/SlidingButton.js";
import styles from "./login.module.css";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import logo from "../../assets/Logo.png";
import cardA from "../../assets/login/cardA.png";
import cardB from "../../assets/login/cardB.png";
import videoBg from "../../assets/images/loginVideo.mp4";
function LoginPage() {

  const { RiveComponent } = useRive({
    src: "https://res.cloudinary.com/dq4y3mssl/raw/upload/v1749104377/hul_bhdx4d.riv",
    autoplay: true,
  });
  const { RiveComponent: RiveComponent2 } = useRive({
    src:"https://res.cloudinary.com/dq4y3mssl/raw/upload/v1749104190/loginLogo_yz1p4w.riv",
    autoplay: true,
  });

    const { instance } = useMsal();

    
  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(e => {
      console.error(e);
    });
  };
  return (
    <div className={styles.container}>
      <video
        className={styles.backgroundVideo}
        autoPlay
        muted
        loop
        playsInline
      >
        <source src={videoBg} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <img
        src={logo}
        width={200}
        height={100}
        alt="Unilever Logo"
        className={styles.logo}
      />
      <div className={styles.textCenter}>
        <div className={styles.title}>
          Supply Chain Nerve Center
        </div>
        <div className={styles.subtitle}>
          Unlocking supply chain capabilities with Plan, Source, Make and
          Deliver
        </div>
      </div>
      <div className={`${styles.riveContainer} ${styles.riveBlock}`}>
        <RiveComponent className={`${styles.riveComponent}`} style={{ height: "300px" , width: 1000}}/>
        <div className={`${styles.loginCard} ${styles.loginBlock}`}>
          <div className={styles.cardContent}>
            <div className={styles.cardHeader}>
              <div className={styles.cardHeaderContent}>
                <div className={styles.welcomeText}>
                  Welcome to <br /> Samarth Portal
                </div>
                <img
                  src={cardA}
                  width={100}
                  height={100}
                  alt="Unilever Bg1"
                  className="cardA"
                />
              </div>
              <RiveComponent2
                className={`${styles.samarth}`}
              />
              <img
                src={cardB}
                width={400}
                height={200}
                alt="Unilever Bg2"
                className={`${styles.cardB}`}
              />
            </div>
            <div className={styles.slidingButton}>
              <SlidingButton onClick={handleLogin}>
                <div className={styles.buttonContent}>
                  <div className={styles.buttonText}>Log in</div>
                  <div className={styles.buttonIcon}>
                    <div className={styles.iconWrapper}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M7 17.3688L16.7153 11.8008L7 6.19629" fill="white" />
                      </svg>
                    </div>
                    -
                  </div>
                </div>
              </SlidingButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default LoginPage;